//
// JRunScript.js
//

function JRunScript(data) {
    data = data?.JTurn?.JRunScript ?? {};

    for (const lang in data) {
        if (lang == 'javascript') {
            for (const script of data[lang]) {
                eval(decodeEntity(script));
            }
        }
    }
}

// Make available globally
window.JRunScript = JRunScript;